const actionTypes = {
  FETCH_QUIZES_START: 'FETCH_QUIZES_START',
  FETCH_QUIZES_SUCCESS: 'FETCH_QUIZES_SUCCESS',
  FETCH_QUIZES_ERROR: 'FETCH_QUIZES_ERROR',
  FETCH_QUIZ_SUCCESS: 'FETCH_QUIZ_SUCCESS',
  QUIZ_SET_STATE: 'QUIZ_SET_STATE',
  FINISH_QUIZ: 'FINISH_QUIZ',
  QUIZ_NEXT_QUESTION: 'QUIZ_NEXT_QUESTION',
  QUIZ_RETRY: 'QUIZ_RETRY',
  CREATE_QUIZ_QUESTION: 'CREATE_QUIZ_QUESTION',
  RESET_QUIZ_CREATION: 'RESET_QUIZ_CREATION',
  AUTH_SUCCESS: 'AUTH_SUCCESS',
  AUTH_LOGOUT: 'AUTH_LOGOUT',
};

export default actionTypes;
